module.exports = __webpack_public_path__ + "static/media/ssg4.d9e045b3.png";